export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "61ca1e40-5a43-43b6-9784-0e6f5d4a74b7";
export const MODAL_CLOSE_SEC = 2.5;
